import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

export const Hero = () => {
  const heroBg = "https://static.prod-images.emergentagent.com/jobs/a7429fec-8104-4b76-a496-937d25753b8d/images/0ec54bc4fdc5edc8e5702a01a2f8ddc0d9910b228b9fd090d736fa5d64cee211.png";

  return (
    <section data-testid="hero" className="relative min-h-[100svh] flex items-center pt-24 pb-16 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img src={heroBg} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-ink-950/95 via-ink-900/85 to-ink-950/95" />
        <div className="absolute inset-0 grid-bg opacity-50" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(6,182,212,0.12),transparent_50%)]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8 w-full">
        <div className="max-w-4xl">
          {/* Status badge */}
          <div data-testid="hero-status" className="inline-flex items-center gap-2.5 px-3 py-1.5 rounded-full border border-cyan-500/30 bg-cyan-500/5 mb-8">
            <span className="relative flex w-2 h-2">
              <span className="absolute inline-flex w-full h-full rounded-full bg-cyan-400 opacity-75 animate-ping" />
              <span className="relative inline-flex w-2 h-2 rounded-full bg-cyan-400" />
            </span>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-300">
              Control Room · 24/7 · Online
            </span>
          </div>

          <h1 data-testid="hero-headline" className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-tighter">
            Protecting Critical
            <br />
            <span className="text-gradient-cyan">UK Infrastructure</span>
            <br />
            with Intelligence.
          </h1>

          <p data-testid="hero-sub" className="mt-7 text-lg text-slate-300 max-w-xl leading-relaxed">
            UK-wide SIA-licensed manned guarding, K9 patrols, CCTV tower hire and 24/7 control room monitoring — engineered into one integrated security operation for construction sites, substations, industrial units and events.
          </p>

          <div className="mt-9 flex flex-wrap gap-3">
            <Link
              to="/contact"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-ink-950 font-bold tracking-wide rounded-md px-6 py-3.5 text-sm transition-colors"
            >
              Speak to a Consultant
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/services"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-2 border border-white/20 hover:border-white/40 bg-white/0 hover:bg-white/5 text-white font-medium rounded-md px-6 py-3.5 text-sm transition"
            >
              Explore Services
            </Link>
          </div>

          {/* Trust line */}
          <div className="mt-12 flex flex-wrap gap-x-7 gap-y-3 text-sm text-slate-400">
            {["SIA Licensed", "Nationwide UK", "Rapid Response", "ISO-aligned"].map((t) => (
              <div key={t} className="flex items-center gap-2">
                <ShieldCheck className="w-4 h-4 text-cyan-400" />
                <span>{t}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
